<h1 class="u-sr-only">{{ 'Toolkit.Menu.My_Toolkit' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card toolkit">
					<loader-overlay *ngIf="vm.loading"></loader-overlay>

					<div class="container container-narrow">
						<button class="btn-back" type="button" (click)="vm.close()">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
							{{ 'Toolkit.Common.Back' | translate }}
						</button>

						<div class="toolkit__emptyPane" *ngIf="!vm.loading && vm.error">
							<div class="toolkit__emptyTitle">{{ 'Toolkit.Assign.LoadError.Title' | translate }}</div>
							<div class="toolkit__emptyText">{{ 'Toolkit.Assign.LoadError.Text' | translate }}</div>
						</div>

						<!-- ===================== Exercise ===================== -->
						<ng-container *ngIf="!vm.loading && !vm.error && vm.kind === 'exercise' && vm.item">
							<div class="exercise-header">
								<div class="resource-meta">
									<span class="resource-meta-item badge badge-blue">{{ vm.resourceFormatLabel(vm.item?.format) | translate }}</span>
									<span class="resource-meta-item" *ngIf="vm.theme?.name">{{ vm.theme.name | translate }}</span>
									<span class="resource-meta-item" *ngIf="vm.item.durationMinutes != null">{{ vm.item.durationMinutes }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
								</div>
								<h1>{{ vm.item.title || vm.item.name || vm.item.id }}</h1>
								<p class="text-muted mt-sm">{{ vm.item.summary || '' }}</p>
							</div>

							<div *ngIf="vm.assignmentNote" class="exercise-therapist-note">
								<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
								<p>{{ vm.assignmentNote }}</p>
							</div>

							<div class="exercise-body">
								<ng-container *ngFor="let b of (vm.blocks || [])">
									<ng-container [ngSwitch]="b.type">
										<div *ngSwitchCase="'psychoeducation'">
											<div class="psychoed-content" *ngIf="vm.content?.sections?.length">
												<ng-container *ngFor="let s of vm.content.sections">
													<div class="highlight-box" *ngIf="s.type === 'highlight'" [innerHTML]="s.html"></div>
													<div *ngIf="s.type !== 'highlight'" [innerHTML]="s.html"></div>
												</ng-container>
											</div>
										</div>

										<div *ngSwitchCase="'reflections'">
											<div class="exercise-subheader">{{ 'Toolkit.Preview.Reflect' | translate }}</div>
											<div class="field-group" *ngFor="let q of b.questions; let i = index">
												<label>{{ q }}</label>
												<textarea
													rows="3"
													class="form-input"
													[disabled]="vm.isReadOnly"
													[(ngModel)]="vm.response['reflection_' + i]"
													placeholder="{{ 'Toolkit.Preview.ReflectionPlaceholder' | translate }}"></textarea>
											</div>
										</div>

										<div *ngSwitchCase="'interactive'">
											<div class="exercise-section" *ngIf="vm.content?.instructions">
												<p class="text-muted mb-md">{{ vm.content.instructions }}</p>
											</div>

											<div class="exercise-form" *ngIf="vm.content?.fields">
												<ng-container *ngFor="let f of (vm.content.fields || [])">
													<ng-container *ngIf="vm.renderFieldByType(f) as fd">
														<div class="field-group" *ngIf="fd.kind !== 'subheader'">
															<label>
																{{ f.label || f.id }}
																<span *ngIf="f.required === true"> *</span>
															</label>

															<input
																*ngIf="fd.kind === 'text'"
																type="text"
																class="form-input"
																[disabled]="vm.isReadOnly"
																[(ngModel)]="vm.response[f.id]"
																[placeholder]="f.placeholder || ''">

															<select
																*ngIf="fd.kind === 'select'"
																class="form-input"
																[disabled]="vm.isReadOnly"
																[(ngModel)]="vm.response[f.id]">
																<option value="">{{ 'Toolkit.Preview.SelectPlaceholder' | translate }}</option>
																<option *ngFor="let opt of (fd.options || [])" [value]="opt">{{ opt }}</option>
															</select>

															<ng-container *ngIf="fd.kind === 'chips'">
																<div class="pattern-chips">
																<button
																	type="button"
																	class="pattern-chip"
																	[disabled]="vm.isReadOnly"
																	[class.selected]="vm.isChipSelected(f.id, opt)"
																	[attr.title]="opt.hint || null"
																	(click)="vm.selectChip(f.id, opt, $event)"
																	(pointerup)="vm.selectChip(f.id, opt, $event)"
																	*ngFor="let opt of (fd.chipOptions || [])">
																	{{ opt.label }}
																</button>
																</div>
															</ng-container>

															<textarea
																*ngIf="fd.kind === 'textarea'"
																rows="3"
																class="form-input"
																[disabled]="vm.isReadOnly"
																[(ngModel)]="vm.response[f.id]"
																[placeholder]="f.placeholder || ''"></textarea>

															<input *ngIf="fd.kind === 'number'" type="number" class="form-input" [disabled]="vm.isReadOnly" [(ngModel)]="vm.response[f.id]">
															<input *ngIf="fd.kind === 'date'" type="date" class="form-input" [disabled]="vm.isReadOnly" [(ngModel)]="vm.response[f.id]">
															<input *ngIf="fd.kind === 'time'" type="time" class="form-input" [disabled]="vm.isReadOnly" [(ngModel)]="vm.response[f.id]">

															<div *ngIf="fd.kind === 'range'" class="slider-field">
																<span class="text-sm text-muted">{{ f.min }}</span>
																<input type="range" [disabled]="vm.isReadOnly" [min]="f.min" [max]="f.max" [(ngModel)]="vm.response[f.id]">
																<span class="slider-value">{{ vm.response[f.id] || vm.fieldMidValue(f) }}</span>
																<span class="text-sm text-muted">{{ f.max }}</span>
															</div>
														</div>

														<div *ngIf="fd.kind === 'subheader'" class="exercise-subheader">{{ f.label || f.id }}</div>
													</ng-container>
												</ng-container>
											</div>
										</div>

										<div *ngSwitchCase="'cta_complete'" style="margin-top:var(--tk-space-xl); display:flex; gap:var(--tk-space-md); flex-wrap:wrap;">
											<button *ngIf="!vm.isReadOnly" class="btn-primary" type="button" [disabled]="vm.submitting" (click)="vm.submitExercise()">
												{{ vm.submitting ? ('Toolkit.Common.Loading' | translate) : ('Toolkit.Preview.CompleteCta' | translate) }}
											</button>
											<button *ngIf="vm.isReadOnly && vm.canRepeatExercise" class="btn-outline" type="button" (click)="vm.repeatExercise()">
												{{ 'Toolkit.Preview.RepeatCta' | translate }}
											</button>
										</div>

										<div *ngSwitchCase="'unsupported_content'" class="preview-disabled-note">
											<p class="text-sm text-muted">{{ 'Toolkit.Preview.ContentUnavailable' | translate }}</p>
											<pre class="toolkit__detailJson" style="max-height:260px; overflow:auto;">{{ vm.item.contentJson || vm.item.content_json }}</pre>
										</div>
									</ng-container>
								</ng-container>
							</div>
						</ng-container>

						<!-- ===================== Survey ===================== -->
						<ng-container *ngIf="!vm.loading && !vm.error && vm.kind === 'survey'">
							<ng-container *ngIf="vm.showSurveyResults && vm.isEek2Survey">
								<div *ngIf="vm.assignmentNote" class="exercise-therapist-note" style="margin-bottom:var(--tk-space-lg);">
									<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
									<p>{{ vm.assignmentNote }}</p>
								</div>

								<toolkit-eek2-results
									[assessment]="vm.assessment"
									[questions]="vm.rawQuestions || vm.questions"
									[answers]="vm.answers"
									[completedAt]="vm.assessmentAssignment?.completedAt || vm.assessmentAssignment?.updatedAt"
									[showHistoryButton]="!!vm.assignmentId"
									(historyRequested)="vm.openEek2History()">
								</toolkit-eek2-results>
							</ng-container>

							<ng-container *ngIf="vm.showSurveyResults && !vm.isEek2Survey">
								<div *ngIf="vm.assignmentNote" class="exercise-therapist-note" style="margin-bottom:var(--tk-space-lg);">
									<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
									<p>{{ vm.assignmentNote }}</p>
								</div>

								<toolkit-survey-results
									[assessment]="vm.assessment"
									[questions]="vm.rawQuestions || vm.questions"
									[scoring]="vm.scoring"
									[assignment]="vm.assessmentAssignment"
									[answers]="vm.answers"
									[audience]="'client'">
								</toolkit-survey-results>
							</ng-container>

							<ng-container *ngIf="!vm.showSurveyResults && vm.questions && vm.currentItem() as cur">
								<div *ngIf="vm.step === 0" class="exercise-header" style="margin-bottom:var(--tk-space-lg);">
									<div class="resource-meta" style="margin-bottom:var(--tk-space-sm);">
										<span class="resource-meta-item badge badge-blue">{{ 'Toolkit.Assessment.Common.Badge' | translate }}</span>
										<span class="resource-meta-item">{{ vm.questions.itemCount || vm.totalQuestions() }} {{ 'Toolkit.Assessment.Common.Questions' | translate }}</span>
										<span class="resource-meta-item" *ngIf="vm.assessment?.durationMinutes != null || vm.assessment?.duration_minutes != null">
											{{ vm.assessment?.durationMinutes || vm.assessment?.duration_minutes }} {{ 'Toolkit.Common.Minutes' | translate }}
										</span>
									</div>
									<h1>{{ vm.assessment?.title || vm.questions.code }} — {{ vm.questions.fullTitle || '' }}</h1>
									<p class="text-muted mt-sm">{{ vm.assessment?.description || '' }}</p>
								</div>

								<div *ngIf="vm.assignmentNote" class="exercise-therapist-note" style="margin-bottom:var(--tk-space-lg);">
									<div class="note-label">{{ 'Toolkit.Preview.FromTherapist' | translate }}</div>
									<p>{{ vm.assignmentNote }}</p>
								</div>

								<div class="card privacy-card" style="margin-bottom:var(--tk-space-lg);">
									<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#717680" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
									<p class="text-sm text-muted">{{ 'Toolkit.Assessment.Common.Privacy' | translate }}</p>
								</div>

								<div class="questionnaire-step">
									<div class="q-number">{{ 'Toolkit.Assessment.Common.Question' | translate }} {{ vm.step + 1 }} {{ 'Toolkit.Assessment.Common.Of' | translate }} {{ vm.totalQuestions() }}</div>
									<div class="q-timeframe" *ngIf="vm.questions.timeframeText">{{ vm.questions.timeframeText }}</div>
									<div class="q-text">{{ cur.text }}</div>
									<div class="q-options">
										<button
											type="button"
											class="q-option"
											[ngClass]="{ selected: vm.answers[vm.step] === opt.value }"
											(click)="vm.selectAnswer(opt.value)"
											[disabled]="vm.isSurveyReadOnly"
											*ngFor="let opt of vm.questions.responseScale">
											<span class="q-radio"></span>
											<span>{{ opt.label }}</span>
										</button>
									</div>
								</div>

								<div class="q-nav">
									<button class="btn-outline btn-sm" type="button" (click)="vm.prev()" [disabled]="vm.step === 0" [style.opacity]="vm.step === 0 ? 0.3 : 1">
										{{ 'Toolkit.Assessment.Common.Previous' | translate }}
									</button>
									<span class="text-sm text-muted">{{ vm.step + 1 }} / {{ vm.totalQuestions() }}</span>

									<ng-container *ngIf="vm.step < vm.totalQuestions() - 1">
										<button class="btn-primary btn-sm" type="button" (click)="vm.next()" [disabled]="vm.answers[vm.step] === undefined" [style.opacity]="vm.answers[vm.step] === undefined ? 0.5 : 1">
											{{ 'Toolkit.Assessment.Common.Next' | translate }}
										</button>
									</ng-container>
									<ng-container *ngIf="vm.step === vm.totalQuestions() - 1">
										<button class="btn-primary btn-sm" type="button" (click)="vm.submitSurvey()" [disabled]="vm.answers[vm.step] === undefined || vm.submitting || vm.isSurveyReadOnly" [style.opacity]="vm.answers[vm.step] === undefined ? 0.5 : 1">
											{{ vm.submitting ? ('Toolkit.Common.Loading' | translate) : ('Toolkit.Assessment.Common.Submit' | translate) }}
										</button>
									</ng-container>
								</div>

								<div class="q-progress">
									<div class="q-progress-bar"><div class="q-progress-fill" [style.width.%]="vm.progressPercent()"></div></div>
									<div class="q-progress-text">{{ vm.progressPercent() | number:'1.0-0' }}% {{ 'Toolkit.Assessment.Common.Complete' | translate }}</div>
								</div>
							</ng-container>

							<div class="toolkit__emptyPane" *ngIf="!vm.loading && !vm.error && !vm.showSurveyResults && (!vm.questions || !vm.currentItem())">
								<div class="toolkit__emptyTitle">{{ 'Toolkit.Assessment.Preview.NoData.Title' | translate }}</div>
								<div class="toolkit__emptyText">{{ 'Toolkit.Assessment.Preview.NoData.Text' | translate }}</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
